























































// Vue
import { defineComponent, ref, PropType, computed } from '@vue/composition-api'

// models
import { TaskSheetDescriptionWork } from '@/models/taskSheet'

export default defineComponent({
  name: 'TableWorDescription',
  props: {
    dailyWorks: {
      required: true,
      type: Array as PropType<TaskSheetDescriptionWork[]>
    }
  },
  setup (props) {
    const headers = ref([
      { text: 'DESCRIPCIÓN', key: 'name' },
      { text: 'PRECIO', key: 'price' },
      { text: 'CANTIDAD', key: 'amount' },
      { text: 'SUB TOTAL', key: 'total' },
      { text: 'IMPORTE', key: 'total' }
    ])

    const totalAmount = computed(() => {
      let total = 0
      props.dailyWorks.forEach(d => {
        total += d.amount
      })
      return total
    })

    const total = computed(() => {
      let total = 0
      props.dailyWorks.forEach(d => {
        total += d.total
      })
      return total
    })

    return {
      headers,
      total,
      totalAmount
    }
  }
})
